/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

var timePickerDefaultProps = {
  allowInput: false,
  clearable: false,
  format: "HH:mm:ss",
  hideDisabledTime: true,
  size: "medium",
  steps: [1, 1, 1]
};
var timeRangePickerDefaultProps = {
  allowInput: false,
  clearable: false,
  format: "HH:mm:ss",
  hideDisabledTime: true,
  size: "medium",
  steps: [1, 1, 1]
};

export { timePickerDefaultProps, timeRangePickerDefaultProps };
//# sourceMappingURL=defaultProps.js.map
